import { EditableSubjectData, TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';

import { useUpdateSubjectEditableData } from '../../../../../hooks/api/toolkitComponents.ts';

export const useUpdateInitialSubjectValues = () => {
  const updateSubjectData = useUpdateSubjectEditableData();

  return async (
    orderID: string,
    subject: EditableSubjectData,
    craftsmanQuality?: number,
    isMock?: boolean,
  ) => {
    try {
      const subjectUpdate: EditableSubjectData = {
        ...subject,
        improvements: {
          ...subject.improvements,
          craftsmanQuality,
        },
        propertyIdentification: {
          ...subject.propertyIdentification,
          ...(isMock && {
            locationType: subject.propertyIdentification.locationType ?? 'Suburban',
            zoningCompliance: subject.propertyIdentification.zoningCompliance ?? 'Legal',
            propertyInterest: subject.propertyIdentification.propertyInterest ?? 'Fee Simple',
          }),
        },
      };

      return await updateSubjectData.mutateAsync({
        pathParams: { orderID },
        body: TKV2_ORDER_ATTACHMENT_API.SUBJECT_DATA.PUT.REQUEST.BODY.parse(subjectUpdate),
      });
    } catch (e: unknown) {
      console.error('Failed to update subject', e);
      return undefined;
    }
  };
};
